// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"b05cba4b","909":"11d8a744"}[chunkId] + ".chunk.js";
};